export default __webpack_public_path__ + "static/media/img-brand-innovation.cf2589fa.svg";